import React, { useEffect, useState } from "react";
import "./adminform.css";
import avatars from "../Global/avtar";
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { handleToast, isValidEmail, isValuePresent } from "../../utils";
// import { getLanguages } from '../../services/api/languages';
import { createAdmin } from "../../services/api/admin";

export default function () {
  const [name, setName] = useState("");
  // const [language,setLanguage]=useState('')
  const [Password, setPassword] = useState("");
  // const [applanguage,setAppLanguage]=useState([])
  const [img, setImg] = useState("");
  // eslint-disable-next-line
  const [imagediv, setImagediv] = useState(true);
  // eslint-disable-next-line
  const [up, setUp] = useState(false);
  // eslint-disable-next-line
  const [down, setDown] = useState(false);
  const [IsTrue, setIstrue] = useState(true);
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState("");
  const isEmail = isValidEmail(email) ? true : null;
  const [islength, setIslength] = useState("");
  const requiredFields = [name, email, isEmail, islength, Password];
  const isMobile = window.innerWidth <= 600;

  const handlePassword = (e) => {
    const newValue = e.target.value;
    setPassword(newValue);
    if (newValue.length >= 8) {
      setIslength(true);
    } else {
      setIslength(null);
    }
  };

  const submit = async (e) => {
    const form = new FormData();
    e.preventDefault();
    const admin = {
      name: name,
      role: "admin",
      password: Password,
      email: email,
      photo: img,
    };
    Object.keys(admin).forEach((key) => {
      form.append(key, admin[key]);
    });

    setLoader(true);

    try {
      createAdmin(form)
        .then((response) => {
          if (response.data.status === "success") {
            toast.success(response?.data?.message, {
              position: isMobile ? "top-left" : "top-center",
              style: {
                width: isMobile ? "300px" : "400px",
                textWrap: isMobile && "wrap",
              },
            });
            setIstrue(null);
            setName("");
            setPassword("");
            setEmail("");
            setImg("");
            setImagediv(true);
            setUp(false);
            setDown(false);
            setLoader(false);
            setIslength("");
          }
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          setLoader(false);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      setLoader(false);
      return;
    }
  };

  const fetchLanguageList = async () => {
    // getLanguages()
    //    .then((response) => {
    //      if (response.data.status === "success") {
    //        const appLanguages = [];
    //        response?.data?.data.forEach((element) => {
    //          if (element.app_language === true) {
    //            appLanguages.push(element);
    //          }
    //        });
    //       //  setAppLanguage(appLanguages);
    //      } else {
    //      }
    //    })
    //    .catch((error) => {
    //      console.log(error.message);
    //    });
  };
  useEffect(() => {
    setImg(avatars[0].image);
    fetchLanguageList();
  }, []);

  useEffect(() => {
    const isAllFilled = requiredFields.some((field) => !isValuePresent(field));
    setIstrue(isAllFilled);
  }, [...requiredFields]);

  const remove = (e) => {
    e.preventDefault();
    setIstrue(true);
    setUp(false);
    setDown(false);
    setImagediv(true);
    setName("");
    setPassword("");
    setEmail("");
    setIslength(null);
  };
  // eslint-disable-next-line
  const handleDropdown = () => {
    setDown((prev) => !prev);
    setUp((prev) => !prev);
  };

  return (
    <div className="form2">
      {!loader ? (
        <div className="form2">
          <form onSubmit={submit} action="" style={{ height: "310px" }}>
            <div className="input-type">
              <h3>
                Name <sup>*</sup>
              </h3>
              <input
                type="text"
                placeholder="Enter Your Name"
                required
                value={name}
                style={{ width: "99%" }}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
            <div
              className="mincont"
              style={{ display: "flex", gap: "10px", width: "100%" }}
            >
              <div className="input-type">
                <h3>
                  Password <sup>*</sup>
                </h3>
                <input
                  type="text"
                  placeholder="Enter Your Password"
                  value={Password}
                  onChange={handlePassword}
                  minLength="8"
                  style={{ width: "100%" }}
                />
                {Password.length < 8 && Password && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "0.9rem",
                      marginLeft: "5px",
                    }}
                  >
                    password length must be 8{" "}
                  </p>
                )}
              </div>
              <div className="input-type">
                <h3>
                  Email <sup>*</sup>
                </h3>
                <input
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  style={{ width: "100%" }}
                  required
                />
              </div>
            </div>
            <div className="submit">
              <button
                className="btn1"
                onClick={remove}
                disabled={IsTrue}
                style={{
                  outline: IsTrue ? "none" : " 1px solid var(--admin-page-color)",
                  color: IsTrue ? "#1c1c1c6d" : "var(--admin-page-color)",
                  background: IsTrue ? "rgba(63, 61, 61, 0.07)" : "#FFFFFF",
                  cursor: IsTrue ? "not-allowed" : "pointer",
                }}
                type="button"
              >
                DISCARD CHANGES
              </button>
              <button
                className="btn2"
                style={{
                  outline: IsTrue ? "none" : " 1px solid var(--admin-page-color)",
                  color: IsTrue ? "#1c1c1c6d" : "#ffffff",
                  background: IsTrue ? "rgba(63, 61, 61, 0.07)" : " var(--admin-page-color)",
                  cursor: IsTrue ? "not-allowed" : "pointer",
                }}
                disabled={IsTrue}
                type="submit"
              >
                CREATE
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="loader">
          <CircularProgress style={{ color: "var(--admin-page-color)" }} />
        </div>
      )}
    </div>
  );
}
